import { render } from "./AddPersonalPrice.vue?vue&type=template&id=507f8628"
import script from "./AddPersonalPrice.vue?vue&type=script&lang=js"
export * from "./AddPersonalPrice.vue?vue&type=script&lang=js"

import "./AddPersonalPrice.vue?vue&type=style&index=0&id=507f8628&lang=css"

import exportComponent from "/var/www/gl_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__